import { Button, Stack } from "@mui/material";
import BackPageButton from "components/buttons/BackPageButton";
import PageHeader from "components/PageHeader";
import ROUTES from "constants/routes";
import { ConfirmModalContext } from "context/confirmModalContext";
import { Dispatch, SetStateAction, useContext } from "react";
import { useFormContext } from "react-hook-form";
import { PROMPT_SLIDES } from "../constants";
import { CompetencyMapGenerationFormValues, PromptSlideId } from "../types";

interface HeaderProps {
  setSkippedPromptIds: Dispatch<SetStateAction<PromptSlideId[]>>;
  setActiveSlideId: Dispatch<SetStateAction<PromptSlideId>>;
}

const Header = ({ setSkippedPromptIds, setActiveSlideId }: HeaderProps) => {
  const { handleOpen } = useContext(ConfirmModalContext);
  const form = useFormContext<CompetencyMapGenerationFormValues>();
  const { reset, formState } = form;
  const hasUnsavedChanges = formState.isDirty;

  const handleReset = () => {
    reset();
    setSkippedPromptIds([]);
    setActiveSlideId(PROMPT_SLIDES[0].id);
  };

  const handleOpenResetConfirmModal = () => {
    if (!hasUnsavedChanges) {
      handleReset();
      return;
    }

    handleOpen({
      title: "Сбросить заполненные данные?",
      description: "Все введённые параметры и загруженные документы будут удалены.",
      actionButtonText: "Сбросить",
      handleClick: handleReset,
    });
  };

  return (
    <Stack spacing={1}>
      <BackPageButton
        defaultValue={{
          text: "Список карт компетенций",
          link: `/${ROUTES.COMPETENCE_MAPS}`,
        }}
        confirmNavigationModalProps={{
          shouldConfirm: hasUnsavedChanges,
        }}
      />
      <PageHeader
        containerProps={{ sx: { mb: 0 } }}
        title='Генерация карты компетенций из документов'
        subTitle='Загрузите документы, настройте параметры и отправьте запрос на генерацию карты.'
        CustomButtons={
          <Button
            variant='outlined'
            onClick={handleOpenResetConfirmModal}>
            Сбросить
          </Button>
        }
      />
    </Stack>
  );
};

export default Header;
